import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getGlobalSettings } from '../../services/globalService';
import Navbar from './Navbar';
import Footer from './Footer';

const LayoutWrapper = ({ children }) => {
  const [global, setGlobal] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const fetchData = async () => {
      const data = await getGlobalSettings();
      setGlobal(data);
      setLoading(false);
    };
    fetchData();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-widya-green border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-400 font-bold uppercase tracking-widest text-[10px]">
            Loading WIDYA...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Navbar global={global} />
      <main className="flex-grow">{children}</main>
      <Footer global={global} />
    </div>
  );
};

export default LayoutWrapper;